<router-outlet></router-outlet>
<div *ngFor="let link of links || []" class="c center mt-4">
  <a [routerLink]="link.route" class="soft-link">
    {{ link.name | translate }}
  </a>
</div>
